import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandHeader from './components/BrandHeader';
import LoginForm from './components/LoginForm';
import TrustIndicators from './components/TrustIndicators';
import CredentialsHelper from './components/CredentialsHelper';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in
    const userData = localStorage.getItem('jewelthread_user');
    if (userData) {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-1/2 -right-1/2 w-full h-full bg-gradient-to-bl from-primary/5 via-transparent to-transparent" />
        <div className="absolute -bottom-1/2 -left-1/2 w-full h-full bg-gradient-to-tr from-primary/5 via-transparent to-transparent" />
      </div>

      <div className="relative w-full max-w-md">
        {/* Main Login Container */}
        <div className="bg-card rounded-2xl elevation-2 p-8 border border-border">
          {/* Brand Header */}
          <BrandHeader />

          {/* Login Form */}
          <LoginForm />

          {/* Demo Credentials Helper */}
          <CredentialsHelper />
        </div>

        {/* Trust Indicators */}
        <div className="mt-8">
          <TrustIndicators />
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date()?.getFullYear()} JewelThread. All rights reserved.
          </p>
          <div className="flex items-center justify-center space-x-4 mt-2">
            <a href="#" className="text-xs text-muted-foreground hover:text-primary transition-luxury">
              Privacy Policy
            </a>
            <span className="text-xs text-muted-foreground">•</span>
            <a href="#" className="text-xs text-muted-foreground hover:text-primary transition-luxury">
              Terms of Service
            </a>
            <span className="text-xs text-muted-foreground">•</span>
            <a href="#" className="text-xs text-muted-foreground hover:text-primary transition-luxury">
              Support
            </a>
          </div>
        </div>

        {/* Bottom Progress Indicator/Decoration */}
        <div className="mt-6 flex justify-center">
          <div className="flex space-x-1">
            <div className="w-2 h-2 rounded-full bg-primary"></div>
            <div className="w-2 h-2 rounded-full bg-border"></div>
            <div className="w-2 h-2 rounded-full bg-border"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;